<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="paddingContent">
      <div class="ListMenu">
        <el-form ref="form" :model="listMenuForm" class="searchForm">

          <el-form-item v-if="complainType=='stickers'" label="帖子id：" class="searchItem">
              <el-input v-model="listMenuForm.postId" @change="listMenuForm.postId = listMenuForm.postId.replace(/\D/g,'')"></el-input>
          </el-form-item>

          <el-form-item v-else label="評論id：" class="searchItem">
              <el-input v-model="listMenuForm.commentId" @change="listMenuForm.postId = listMenuForm.postId.replace(/\D/g,'')"></el-input>
          </el-form-item>

          <el-form-item label="投訴類型">
            <el-select v-model="listMenuForm.type" placeholder="请选择">
              <el-option label="全部" value="0"></el-option>
              <el-option label="仇恨言論或人身攻擊" value="1"></el-option>
              <el-option label="垃圾或廣告訊息" value="2"></el-option>
              <el-option label="詐騙或不實信息" value="3"></el-option>
              <el-option label="色情訊息" value="4"></el-option>
              <el-option label="有害或危險內容" value="5"></el-option>
              <el-option label="其他" value="6"></el-option>

            </el-select>
          </el-form-item>

          <el-form-item label="投訴次數">
            <el-select v-model="listMenuForm.count" placeholder="请选择">
              <el-option label="全部" value="0"></el-option>
              <el-option label="1-9次" value="single"></el-option>
              <el-option label="10次及以上" value="double"></el-option>

            </el-select>
          </el-form-item>

          <el-form-item label="開始時間"  class="searchItem hidden-lg-and-down">
            <el-date-picker v-model="listMenuForm.startTime" type="datetime"  placeholder="選擇時間"></el-date-picker>
          </el-form-item>

          <el-form-item label="結束時間"  class="searchItem hidden-lg-and-down">
            <el-date-picker v-model="listMenuForm.endTime" type="datetime" placeholder="選擇時間"></el-date-picker>
          </el-form-item>
        </el-form>

      </div>
      <div class="ListMenu">
        <el-form ref="form" :model="listMenuForm" class="searchForm">
          <el-form-item label="開始時間"  class="searchItem hidden-xl-only">
            <el-date-picker v-model="listMenuForm.startTime" type="datetime"  placeholder="選擇時間"></el-date-picker>
          </el-form-item>

          <el-form-item label="結束時間"  class="searchItem hidden-xl-only">
            <el-date-picker v-model="listMenuForm.endTime" type="datetime" placeholder="選擇時間"></el-date-picker>
          </el-form-item>
        </el-form>

      </div>
      <div class="MenuBtnWrap">
          <div class="btn" @click="search()">查詢</div>
          <div class="btn borderBtn" @click="reset()">重置</div>
          <div v-if="complainType=='stickers'" style="background: #fff;color: #6c3dea;border: 1px solid #6c3dea;" class="btn borderBtn" @click="toggleType('comment')">評論投訴</div>
          <div v-else class="btn borderBtn" style="background: #fff;color: #6c3dea;border: 1px solid #6c3dea;" @click="toggleType('stickers')">帖子投訴</div>


      </div>
      <div class="tableWrap"  v-if="complainType=='stickers'">

        <el-table ref="tableStickers" height='660px' stripe :data="complainList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img src="@/assets/images/common/no_data.png" alt="暂无数据" :style="{width:'244px',height:'139px'}">
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in complainTable" :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width">
          </el-table-column>
          <el-table-column
            label="投訴類型"
            width="180">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <div v-for="(item, index) in scope.row.complainTypeList" :key="index">
                  <p v-if="item=='1'">仇恨言論或人身攻擊</p>
                  <p v-if="item=='2'">垃圾或廣告訊息</p>
                  <p v-if="item=='3'">詐騙或不實信息</p>
                  <p v-if="item=='4'">色情訊息</p>
                  <p v-if="item=='5'">有害或危險內容</p>
                  <p v-if="item=='6'">其他</p>
                </div>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">{{ scope.row.complaintType }}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width='200'
            fixed="right">
            <template slot-scope="scope">
              <el-button @click="toEditSubject(scope.row.stickersId)" type="text" >詳情</el-button>
              <el-button @click="toComplaintReason(scope.row.stickersId,1)" type="text" >投訴詳情</el-button>

              <el-button @click="delSubject(scope.row.stickersId)" type="text" >刪除</el-button>

              <el-button v-if="scope.row.complainCount > 9"  @click="recover(scope.row.id)" type="text" >恢復</el-button>
              <el-button v-else style="color:#909090" type="text" >恢復</el-button>
            </template>
          </el-table-column>
        </el-table>


      </div>
      <div class="tableWrap" v-else >
        <el-table ref="tableComment" height='660px' stripe :data="commentComplainList" style="width:100%;">
          <el-table-column
            v-for="(item, index) in commentComplainTable" :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width">
          </el-table-column>
          <el-table-column
            label="投訴類型"
            width="180">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <div v-for="(item, index) in scope.row.complainTypeList" :key="index">
                  <p v-if="item=='1'">仇恨言論或人身攻擊</p>
                  <p v-if="item=='2'">垃圾或廣告訊息</p>
                  <p v-if="item=='3'">詐騙或不實信息</p>
                  <p v-if="item=='4'">色情訊息</p>
                  <p v-if="item=='5'">有害或危險內容</p>
                  <p v-if="item=='6'">其他</p>
                </div>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">{{ scope.row.complaintType }}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width='160'
            fixed="right">
            <template slot-scope="scope">
              <el-button @click="delSubject(scope.row.commentId)" type="text" >刪除</el-button>
              <el-button @click="toComplaintReason(scope.row.commentId,2)" type="text" >投訴詳情</el-button>
              <el-button v-if="scope.row.complainCount > 9"  @click="recover(scope.row.id)" type="text" >恢復</el-button>
              <el-button v-else style="color:#909090" type="text" >恢復</el-button>

            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count='5'
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';
export default {
  data () {
    return {
      navBlock: '社區',
      navtitle: '帖子投訴列表',
      listMenuForm:{
        postId: '',
        commentId: '',
        count: '0',
        type: '0',
        startTime: '',
        endTime: '',
      },
      complainType: 'stickers',
      complainList:[],
      complainTable: [
        {
          prop: 'stickersId',
          label: '帖子id',
          width: '140'
        }, {
          prop: 'title',
          label: '帖子標題',
          width: ''
        },
        // {
        //   prop: 'complaintType',
        //   label: '投訴類型',
        //   width: '170'
        // },
        {
          prop: 'complainCount',
          label: '投訴原因',
          width: '110'
        },
        {
          prop: 'complainCount',
          label: '投訴次數',
          width: '110'
        }, {
          prop: 'complainTime',
          label: '投訴時間',
          width: '140'
        },
      ],
      commentComplainList:[],
      commentComplainTable: [
        {
          prop: 'commentId',
          label: '評論id',
          width: '140'
        },
        {
          prop: 'stickersId',
          label: '帖子id',
          width: '140'
        }, {
          prop: 'title',
          label: '帖子標題',
          width: ''
        }, {
          prop: 'context',
          label: '評論內容',
          width: '200'
        },
        //  {
        //   prop: 'complaintType',
        //   label: '投訴類型',
        //   width: '170'
        // },

        {
          prop: 'complainCount',
          label: '投訴次數',
          width: '110'
        }, {
          prop: 'complainCount',
          label: '投訴原因',
          width: '110'
        },{
          prop: 'complainTime',
          label: '投訴時間',
          width: '140'
        },
      ],
      currentPage: 1, // 分页
      currentPageSize: 10,
      total: 0,
      dialogVisible: false,
    }
  },
  created(){
    this.getSubComList();
  },
  activated(){
    if (this.currentPage === 1){
      this.getSubComList();
    }
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    // 获取帖子投诉列表信息
    getSubComList(){
      let _this = this;
      let param ={
        stickersId:_this.listMenuForm.postId,
        pageNo: _this.currentPage,
        pageSize: _this.currentPageSize,
        complaintCount: _this.listMenuForm.count,//投诉次数
        complaintType: Number(_this.listMenuForm.type),//投诉类型
        beforeTime: (_this.listMenuForm.startTime === ''|| _this.listMenuForm.startTime === null)  ? null  : _this.$formatDate(_this.listMenuForm.startTime),
        afterTime: (_this.listMenuForm.endTime === ''|| _this.listMenuForm.endTime === null)  ? null  : _this.$formatDate(_this.listMenuForm.endTime),
      }
      this.$post('/unity/stickersComplaintList', param, this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            res.data.list.forEach(v=>{
              v.complainTime = this.$getTime(v.complainTime);
              v.complainTypeList = v.complaintType.split(',')

              v.complaintType = v.complaintType[0]
              switch (v.complaintType) {
                case '1':
                  v.complaintType = '仇恨言論或人身攻擊'
                  break
                case '2':
                  v.complaintType = '垃圾或廣告訊息'
                  break
                case '3':
                  v.complaintType = '詐騙或不實信息'
                  break
                case '4':
                  v.complaintType = '色情訊息'
                  break
                case '5':
                  v.complaintType = '有害或危險內容'
                  break
                case '6':
                  v.complaintType = '其他'
                  break
              }
            })
            _this.complainList = res.data.list;
            _this.total = res.data.allRow;
          } else {
            this.$propMessage(res.message, 'error');
          };
        });
    },
    // 获取評論投诉列表信息
    getCommentComList(){
      let _this = this;
      let param ={
        stickersId: _this.listMenuForm.postId,
        complaintId: _this.listMenuForm.commentId,
        pageNo: _this.currentPage,
        pageSize: _this.currentPageSize,
        complaintCount: _this.listMenuForm.count,//投诉次数
        complaintType: Number(_this.listMenuForm.type),//投诉类型
        beforeTime: (_this.listMenuForm.startTime === ''|| _this.listMenuForm.startTime === null)  ? null  : _this.$formatDate(_this.listMenuForm.startTime),
        afterTime: (_this.listMenuForm.endTime === ''|| _this.listMenuForm.endTime === null)  ? null  : _this.$formatDate(_this.listMenuForm.endTime),
      }
      this.$post('/unity/community/comment/getlist', param, this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            res.data.list.forEach(v=>{
              v.complainTime = this.$getTime(v.complainTime)
              v.complainTypeList = v.complaintType.split(',')
              v.complaintType = v.complaintType[0]
              switch (v.complaintType) {
                case '1':
                  v.complaintType = '仇恨言論或人身攻擊'
                  break
                case '2':
                  v.complaintType = '垃圾或廣告訊息'
                  break
                case '3':
                  v.complaintType = '詐騙或不實信息'
                  break
                case '4':
                  v.complaintType = '色情訊息'
                  break
                case '5':
                  v.complaintType = '有害或危險內容'
                  break
                case '6':
                  v.complaintType = '其他'
                  break
              }
            })
            _this.commentComplainList = res.data.list;
            _this.total = res.data.allRow;
          } else {
            this.$propMessage(res.message, 'error');
          };
        });
    },
    toggleType(type){
      let _this = this;
      _this.listMenuForm = {
        postId: '',
        commentId: '',
        count: '0',
        type: '0',
        startTime: '',
        endTime: '',
      }
      _this.currentPage = 1;
      _this.complainType = type;
      if(type == 'stickers') {
        _this.getSubComList();
        _this.navtitle = '帖子投訴列表';
      } else{
        _this.getCommentComList();
        _this.navtitle = '評論投訴列表';

      }
      let ref=(type=='stickers'?'tableStickers':'tableComment')
        setTimeout(()=>{
          this.$refs[ref].doLayout()
        },1)
    },
    // 分页
    handleCurrentChange (val) {
      let _this = this;
      _this.currentPage = val;
      if(_this.complainType == 'stickers') {
        _this.getSubComList();

      } else {
        _this.getCommentComList();

      }
    },
    // 恢复
    recover(id){
      let _this = this;
      _this.$post(`/unity/community/${_this.complainType}/${id}`, {}, _this.$GLOBAL.jsonConfig)
        .then((res) => {
            _this.dialogVisible  = true;
            if(res.code === '00000'){
                _this.$propMessage('恢復成功，請稍候', 'success',
                  function(){
                  _this.dialogVisible = false;
                  _this.currentPage = 1;
                  if(_this.complainType == 'stickers') {
                    _this.getSubComList();
                  } else {
                    _this.getCommentComList()
                  }
                 });

              } else {
                _this.$propMessage(res.message, 'error',
                  function(){
                    _this.dialogVisible = false;
                 });
              };
        })

    },
    // 删除
    delSubject(id){
      let _this = this;
      let title = _this.complainType == 'stickers' ? '帖子' : '評論'
      _this.$confirm(`是否刪除該${title}?`, '提示信息', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          center: true,
        closeOnClickModal: false
        }).then(()=> {
          // 确认删除的回调
          _this.$del(`/unity/community/${_this.complainType}/${id}`, {}, _this.$GLOBAL.jsonConfig)
            .then((res) => {
              _this.dialogVisible  = true;
              if(res.code === '00000'){

                _this.$propMessage('刪除成功，請稍候', 'success',
                  function(){
                  _this.dialogVisible = false;
                  _this.currentPage = 1;
                  if(_this.complainType == 'stickers') {
                    _this.getSubComList();
                  } else {
                    _this.getCommentComList()
                  }
                 });

              } else {
                _this.$propMessage(res.message, 'error',
                  function(){
                  _this.dialogVisible = false;
                 });
              };
          });
      });
    },
    // 进入帖子詳情
    toEditSubject (id,) {
      this.$router.push(`/postDetails?id=${id}&type=com`);
    },
    //投訴詳情
    toComplaintReason(id,type){
      this.$router.push(`/complaintReason?id=${id}&type=${type}`);
    },
    //重置搜索條件
    reset(){
      let _this = this;
      _this.listMenuForm={
        postId: '',
        commentId: '',
        count: '0',
        type:'0',
        startTime: '',
        endTime: '',
      }
      if(_this.complainType == 'stickers') {
        _this.getSubComList();
      } else {
        _this.getCommentComList()
      }
    },
    //搜索
    search(){
      let _this = this;
      if (_this.listMenuForm.postId === '' && _this.listMenuForm.commentId === '' && _this.listMenuForm.type === '0' && _this.listMenuForm.count === '0' && _this.listMenuForm.startTime === '' && _this.listMenuForm.endTime==='') {
        _this.dialogVisible = true;
        _this.$propMessage('請輸入至少一個搜索條件','error',function(){
          _this.dialogVisible = false;
        });

        return false;
      };
      if (_this.$compareTime(_this.listMenuForm.startTime, _this.listMenuForm.endTime)) {
        _this.dialogVisible = true;
        _this.$propMessage('開始時間不可以晚於結束時間','error',function(){
          _this.dialogVisible = false;
        });
        return false;
      };
      _this.currentPage = 1;
      if(_this.complainType == 'stickers') {
        _this.getSubComList();
      } else {
        _this.getCommentComList()
      }
    },
  },
  components: {
    NavBar,
    DiaMess,
  }
};
</script>
<style lang="less" scoped>
  .content{
    .paddingContent{
      .ListMenu{
        .MenuBtnWrap{
          display: flex;
          justify-content: flex-end;
          .btn:last-child{
            margin-left: 0.2rem;
          }
        }
      }
      .tableWrap {
        width: 100%;
        height: calc(100% - 152px);
        overflow: auto;
        word-break: break-all;

        @media (max-width: 768px) {
          height: calc(100% - 92px);
        }

        @media (max-width: 420px) {
          height: calc(100% - 112px);
        }
      }
    }
    .topBtn{
      width:50px;
    }
  }
  @media screen and (min-width: 769px) {
    .ListMenu{
        display: flex;
        justify-content: space-between;
        .searchForm{
          flex: 1;
          display: flex;
          justify-content: flex-start;
        }
        .MenuBtnWrap{
          flex: 1;
        }
      }
  }
</style>



// WEBPACK FOOTER //
// src/pages/community/complaintList.vue